import MainPage from './pages/MainPage';
import './styles/styles.scss';

function App() {
  return <MainPage />;
}

export default App;
